import { matchPath } from 'react-router-dom';
import type { TutorialPageDef } from './types';
import { generalTutorials } from './pages/general';
import { adsImageTutorials } from './pages/ads-image';
import { adsVideoTutorials } from './pages/ads-video';
import { workspaceTutorials } from './pages/workspace';

export const TUTORIAL_PAGES: TutorialPageDef[] = [
  ...generalTutorials,
  ...adsImageTutorials,
  ...adsVideoTutorials,
  ...workspaceTutorials,
];

export function findTutorialPage(pathname: string, pages: TutorialPageDef[] = TUTORIAL_PAGES): TutorialPageDef | null {
  return pages.find((page) => page.paths.some((path) => matchPath({ path, end: true }, pathname))) ?? null;
}
